<template>
  <div class="">
    <slot></slot>
  </div>
</template>
<script lang="ts" setup></script>
